export default [
  {
    text: 'Business',
    value: 'business.name',
    apiSort: 'businesses.name',
  },
  {
    text: 'Domain',
    value: 'domain.url',
    apiSort: 'contract_domains.url',
  },
  {
    text: 'Contract owner',
    value: 'owner',
    apiSort: 'users.firstname',
  },
  {
    text: 'Country',
    value: 'country.name',
    apiSort: 'country',
    isCurrency: true,
  },
  {
    text: 'Expires at',
    value: 'expire_at',
  },
  {
    text: 'Status',
    value: 'status.name',
    apiSort: 'status',
  },
];
